import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/reposh-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>How-To Guide in Poshmark Reselling</title>
        <meta
          name='description'
          content='Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/reposh-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/reposh-poshmark' />
        <meta property='og:title' content='How-To Guide in Poshmark Reselling' />
        <meta
          property='og:description'
          content='Poshmark is a mobile app that allows users to buy and sell items online. In this post, we provide a how-to guide for the most common features of the app. We also offer step-by-step instructions on how to use the app for sellers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
